import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import {
  NavigationContainer,
  UserBox,
  LangBox,
  DivisionLabel,
  Breadcrumb,
  LogoContainer,
  UtilityBox,
  LangLink,
  ChatBox,
  MenuBox,
  Overlay,
  Panel,
  Header,
  CloseButtonContainer,
  MinimizedNavBar,
  BreadcrumbContainer,
  BreadcrumbItem,
  Icon,
  BreadcrumbMain,
} from './css';
import SalesForceChat from '../ReactComponent/ChatWindow/SalesForceChat';
import SecondaryNavigation from '../SecondaryNavigation';
import utils from '../../utils/utils';
import { homeUrl, getCurrentLanguage } from '../../utils/func';
import { TOGGLE_ACCOUNT_SIDE_MENU } from '../ReactComponent/AccountSideMenu/actions';
import { routes } from '../../utils/constants';
import { Locales, SalesforceChatLanguages } from '../../utils/enums';
import putCurrentLanguage from './actions';
import mockSecNav from './mockSecNav.json';
import SitecoreContextFactory from '../../lib/SitecoreContextFactory';
import NavLogo from '../../assets/logo/nav_logo.svg';
import ChatIconOrange from '../../assets/icons/chat_icon_orange.svg';
import HamburgerIcon from '../../assets/icons/hamburger_icon.svg';
import UserAvatarIcon from '../../assets/icons/user_avatar.svg';
import XIcon from '../../assets/icons/x_icon.svg';
import ArrowRightBlack from '../../assets/icons/ArrowRightBlack.svg';

class Navigation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      homeUrl: '/',
      panelOpen: false,
    };
  }

  componentDidMount() {
    this.setState({ homeUrl: homeUrl() });
    const CurrentLanguage = getCurrentLanguage();
    this.props.putCurrentLanguage(CurrentLanguage);
  }

  togglePanel = () => this.setState((prevState) => ({ panelOpen: !prevState.panelOpen }));

  removeLocaleFromPathAndSearch = (pathAndSearch) => {
    const pathAndSearchArr = pathAndSearch.split('/');

    // Check to see if locale is at index 1, since "" is at index 0, when we split
    // a string on "/" and the string starts w/ "/", like int the case of pathAndSearch...
    if (pathAndSearchArr[1] !== Locales.English
      && pathAndSearchArr[1] !== Locales.French) {
      // No expected locale found. Return pathAndSearch...
      return pathAndSearch;
    }

    // Expected locale found. Remove locale from pathAndSearch...
    pathAndSearchArr.shift(); // Remove ""
    pathAndSearchArr.shift(); // Remove locale string...

    const pathAndSearchWithoutLocale = `/${pathAndSearchArr.join('/')}`;

    return pathAndSearchWithoutLocale;
  };

  handleAccountSideMenuClick = () => {
    const { isAuthenticated } = this.props;

    if (!isAuthenticated) {
      window.location.href = routes.login;
      return;
    }

    this.props.toggleAccountSideMenu();
  };

  processBreadCrumbs = (currentPageUrl) => {
    const { fields } = this.props;
    const breadcrumbsObject = [];

    const secondaryNavigationData = utils.isDisconnected ? mockSecNav : fields;

    // eslint-disable-next-line no-prototype-builtins
    if (secondaryNavigationData.data.hasOwnProperty('item')) {
      let stillActive = true;

      // eslint-disable-next-line array-callback-return
      secondaryNavigationData.data.item.children.map((item) => {
        if (!stillActive) {
          return;
        }

        if (item.link.jss.value.href.toLocaleLowerCase().indexOf(currentPageUrl.toLocaleLowerCase()) > 0) {
          breadcrumbsObject[0] = { name: item.title ? item.title.value : (item.link.jss ? item.link.jss.value.text : item.name) };
          stillActive = false;
          return;
        }

        if (item.children && item.children.length > 0) {
          // eslint-disable-next-line array-callback-return
          item.children.map((secondItem) => {
            const temporaryFirstItem = item.title ? item.title.value : (item.link.jss ? item.link.jss.value.text : item.name);

            if (secondItem.template.name === 'Navigation-Link'
              && (secondItem.link.jss.value.href.toLocaleLowerCase().indexOf(currentPageUrl.toLocaleLowerCase()) > 0)) {
              breadcrumbsObject[0] = { name: item.title ? item.title.value : (item.link.jss ? item.link.jss.value.text : item.name) };
              breadcrumbsObject[1] = { name: secondItem.link.jss.value.text };
              stillActive = false;
              return;
            }

            if (secondItem.children && secondItem.children.length > 0) {
              const thirdItemList = secondItem.children;
              // eslint-disable-next-line array-callback-return
              thirdItemList.map((thirdItem) => {
                if (thirdItem.link.jss.value.href.toLocaleLowerCase().indexOf(currentPageUrl.toLocaleLowerCase()) > 0) {
                  breadcrumbsObject[0] = { name: temporaryFirstItem };
                  breadcrumbsObject[1] = {
                    name: secondItem.title ? secondItem.title.value
                      : (secondItem.link.jss ? secondItem.link.jss.value.text : secondItem.name),
                  };
                  breadcrumbsObject[2] = { name: thirdItem.link.jss.value.text };

                  stillActive = false;
                }
              });
            }
          });
        }
      });
    }

    return breadcrumbsObject;
  };

  handleLanguageSubmit = (e) => {
    this.props.putCurrentLanguage(e.target.innerHTML);
  };

  render() {
    // eslint-disable-next-line react/no-unstable-nested-components
    const Breadcrumbs = () => (
      <Route
        path="*"
        render={
          (props) => {
            let parts = props.location.pathname.split('/');
            const place = parts[parts.length - 1];
            // eslint-disable-next-line react/no-this-in-sfc
            parts = this.processBreadCrumbs(place);
            return (
              Object.entries(parts).length > 0
                  && (
                  <BreadcrumbMain>
                    <Breadcrumb>
                      <BreadcrumbContainer>
                        {
                          Object.keys(parts).map((crumb, index) => (
                            <React.Fragment key={`breadcrumb-${index}`}>
                              {crumb !== parts[crumb].name ? (
                                <>
                                  {index === 0
                                  && (
                                  <BreadcrumbItem>
                                    <p>{t('BreadcrumbHomepageTitle')}</p>
                                  </BreadcrumbItem>
                                  )}
                                  <BreadcrumbItem>
                                    <Icon src={ArrowRightBlack} />
                                  </BreadcrumbItem>
                                  <BreadcrumbItem>
                                    <p>{parts[crumb].name}</p>
                                  </BreadcrumbItem>
                                </>
                              ) : ''}
                            </React.Fragment>
                          ))
                        }
                      </BreadcrumbContainer>
                    </Breadcrumb>
                  </BreadcrumbMain>
                  )
            );
          }
        }
      />
    );

    const { fields, location } = this.props;

    const secondaryNavigationData = utils.isDisconnected ? mockSecNav : fields;

    const { homeUrl } = this.state;

    const pathAndSearch = location.pathname + location.search;

    return (
      <>
        <MinimizedNavBar>
          <LogoContainer href={homeUrl}><object type="image/svg+xml" data={NavLogo} aria-label="Day and Ross Logo" /></LogoContainer>
          <MenuBox onClick={() => this.togglePanel()}>
            <object type="image/svg+xml" data={HamburgerIcon} aria-label="Navigation menu button" />
          </MenuBox>
        </MinimizedNavBar>
        <Overlay $isPanelOpen={this.state.panelOpen} onClick={() => this.togglePanel()} />
        <NavigationContainer>
          <Panel $isOpen={this.state.panelOpen}>
            <Header>
              <LogoContainer href={homeUrl}>
                <object type="image/svg+xml" data={NavLogo} aria-label="Day and Ross Logo" />
              </LogoContainer>
              <CloseButtonContainer onClick={() => this.togglePanel()}>
                <object type="image/svg+xml" data={XIcon} aria-label={t('Close')} />
              </CloseButtonContainer>
            </Header>
            <SecondaryNavigation fields={secondaryNavigationData} isDisplayed={this.state.expanded} />
            <UtilityBox>
              <li>
                <ChatBox
                  onClick={() => SalesForceChat().showChatWindow(
                    window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
                      ? SalesforceChatLanguages.French
                      : SalesforceChatLanguages.English,
                  )}
                >
                  <object type="image/svg+xml" data={ChatIconOrange} aria-label={t('Chat')} />
                  <p>{t('Chat')}</p>
                </ChatBox>
              </li>
              <li>
                <UserBox onClick={this.handleAccountSideMenuClick}>
                  <object type="image/svg+xml" data={UserAvatarIcon} aria-label="User avatar" />
                  {this.props.isAuthenticated
                    ? <DivisionLabel field={this.props.fullName || this.props.userEmail} />
                    : <p>{t('SignInUp')}</p>}
                </UserBox>
              </li>
              <li>
                <LangBox>
                  <LangLink
                    to={`/${Locales.English}${this.removeLocaleFromPathAndSearch(pathAndSearch)}`}
                    isActive={() => SitecoreContextFactory.context.language === Locales.English}
                    onClick={(e) => this.handleLanguageSubmit(e)}
                  >
                    EN
                  </LangLink>
                  <span />
                  <LangLink
                    to={`/${Locales.French}${this.removeLocaleFromPathAndSearch(pathAndSearch)}`}
                    isActive={() => SitecoreContextFactory.context.language === Locales.French}
                    onClick={(e) => this.handleLanguageSubmit(e)}
                  >
                    FR
                  </LangLink>
                </LangBox>
              </li>
            </UtilityBox>
          </Panel>
        </NavigationContainer>
        <Breadcrumbs />
      </>
    );
  }
}

const mdtp = (dispatch) => ({
  toggleAccountSideMenu: () => dispatch({ type: TOGGLE_ACCOUNT_SIDE_MENU }),
  putCurrentLanguage: (currentLanguage) => dispatch(putCurrentLanguage(currentLanguage)),
});

const mstp = (state) => ({
  isAuthenticated: state.profile.isAuthenticated,
  division: state.profile.division,
  currentLanguage: state.profile.currentLanguage,
  fullName: state.profile.fullName,
  userEmail: state.profile.email,
});

export default connect(mstp, mdtp)(withRouter(Navigation));

Navigation.propTypes = {
  isAuthenticated: PropTypes.bool,
  fields: PropTypes.object,
  location: PropTypes.object,
  putCurrentLanguage: PropTypes.func,
  fullName: PropTypes.string,
  userEmail: PropTypes.string,
  toggleAccountSideMenu: PropTypes.func,
};
